import React, { Component } from 'react';
import { DASHBOARD_SCREEN } from '../../global/Constants';
import { DashboardType } from '../../global/Enum';
import Utilities from '../../global/Utilities';

class DashboardHybrids extends Component {
    constructor(props) {
        super(props);
    }

    getActiveHybridPercent() {
        const { hybridData } = this.props;
        if (hybridData) {
            let totalHybrid = hybridData?.total_hybrid;
            if (totalHybrid > 0) {
                let activeHybrid = hybridData.active_hybrid;
                const percent = (activeHybrid * 100) / totalHybrid;
                return Math.round(percent) + "%";
            } else {
                return 0 + "%";
            }
        }
    }

    getWidthMaxValue() {
        const { hybridData } = this.props;
        if (hybridData) {
            let maxValue = Math.max.apply(Math, hybridData.hybrid_detail.map(function (user) {
                return user.total_hybrid;
            }))
            //Utilities.LogPrint("Hybrid", maxValue);
            return maxValue;
        }
    }

    getBarWidthValue(total) {
        const totalWidth = (total * 100) / this.getWidthMaxValue();
        //Utilities.LogPrint("Width Value", totalWidth);
        return totalWidth;
    }

    getFilledWidth(totalActivity, completedActivity) {
        const width = this.getBarWidthValue(totalActivity);
        const percent = (completedActivity * width) / totalActivity;
        //Utilities.LogPrint("Filled", Math.round(percent) + "%");
        return Math.round(percent) + "%";
    }

    getUnFilledWidth(totalActivity, completedActivity) {
        const width = this.getBarWidthValue(totalActivity);
        const percent = (completedActivity * width) / totalActivity;
        //Utilities.LogPrint("UN-Filled", Math.round(width - percent) + "%");
        return Math.round(width - percent) + "%";
    }


    handleChange = ({ target }) => {
        Utilities.LogPrint("Selected Hybrid", target.value);
        const { onHybridChange } = this.props;
        if (onHybridChange) {
            onHybridChange(target.value);
        }
    }

    render() {
        const { hybrids, hybridData, activeTab } = this.props;
        Utilities.LogPrint("HYBRID_DATA", hybridData);


        if (hybrids && hybrids?.length > 0) {
            return (
                <div id="hybrids" className={activeTab === DashboardType.HYBRID ? "more-menu-body" : "d-none"}>
                    <div className="form-group mt-0 mt-md-4">
                        <select className="form-control"
                            onChange={this.handleChange}>
                            {
                                hybrids.map((item, i) =>
                                    <option key={i} value={item.hybrid_id} >{item.hybrid_name}</option>)
                            }
                            {/* <option value="">Rice</option>
                            <option value="">Rice 1</option>
                            <option value="">Rice 2</option> */}
                        </select>

                    </div>
                    <h6 className="font-weight-medium d-flex">{DASHBOARD_SCREEN.ACTIVE_HYBRIDS}
                        <span className="ml-auto">{hybridData?.active_hybrid}/{hybridData?.total_hybrid}</span>
                    </h6>
                    <div className="progress progress-red1 mb-3">
                        <div className={`progress-bar ${hybridData?.active_hybrid === 0 ? "progress-padding" : ''} `} role="progressbar" style={{ width: this.getActiveHybridPercent() }} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">
                            {this.getActiveHybridPercent()}
                        </div>
                    </div>


                    {/* Hybrids Chart */}
                    <div className="gray-bg bdr-radius-7 p-0 p-md-3">
                        <div className="row mt-3">
                            {
                                hybridData?.hybrid_detail?.length > 0 ?
                                    hybridData?.hybrid_detail?.map((item, i) => (
                                        <div className="col-12 mb-3" key={i}>
                                            <div className="row align-items-center">
                                                <div className="col-2 col-md-3 text-right">
                                                    <label className="mb-0 text-white">{item.hybrid_name}</label>
                                                </div>
                                                <div className="col-10 col-md-9 pl-0">
                                                    <div className="progress double-progress-bar">
                                                        <div
                                                            className={`progress-bar bg-primery ${item?.active_hybrid === 0 ? 'progress-padding' : ''}`}
                                                            style={{ width: this.getFilledWidth(item.total_hybrid, item.active_hybrid) }}
                                                            role="progressbar"
                                                            aria-valuenow="30"
                                                            aria-valuemin="0"
                                                            aria-valuemax="100">{item.active_hybrid}</div>
                                                        <div
                                                            className={`progress-bar bg-white ${item.active_hybrid === 0 ? 'progress-padding' : ''}`}
                                                            role="progressbar"
                                                            style={{ width: this.getUnFilledWidth(item.total_hybrid, item.active_hybrid) }}
                                                            aria-valuenow="20"
                                                            aria-valuemin="0"
                                                            aria-valuemax="100"></div>
                                                        <span>{item.total_hybrid}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )) : null
                            }
                        </div>
                    </div>

                    {/* Hybrids Chart */}
                    {/* <div className="hybrids-chart activite-chart gray-bg d-flex px-3">
                        <ul className="custom-bar-chart">
                            <li>
                                <div className="full-bar" style={{ height: '90%' }}>
                                    <div className="total-bar" style={{ height: '15%' }}>30</div>
                                    <div className="sun-total-bar progress-red-color" style={{ height: '85%' }}>28</div>
                                </div>
                                <div className="bar-title w-100">US1</div>
                            </li>
                            <li>
                                <div className="full-bar" style={{ height: '76%' }}>
                                    <div className="total-bar" style={{ height: '15%' }}>25</div>
                                    <div className="sun-total-bar progress-red-color" style={{ height: '85%' }}>23</div>
                                </div>
                                <div className="bar-title w-100">US2</div>
                            </li>
                            <li>
                                <div className="full-bar" style={{ height: '90%' }}>
                                    <div className="total-bar" style={{ height: '15%' }}>30</div>
                                    <div className="sun-total-bar progress-red-color" style={{ height: '85%' }}>27</div>
                                </div>
                                <div className="bar-title w-100">US3</div>
                            </li>
                            <li>
                                <div className="full-bar" style={{ height: '80%' }}>
                                    <div className="total-bar" style={{ height: '15%' }}>29</div>
                                    <div className="sun-total-bar progress-red-color" style={{ height: '85%' }}>26</div>
                                </div>
                                <div className="bar-title w-100">US4</div>
                            </li>
                            <li>
                                <div className="full-bar" style={{ height: '100%' }}>
                                    <div className="total-bar" style={{ height: '100%' }}>40</div>
                                    <div className="sun-total-bar progress-red-color" style={{ height: '0%' }}></div>
                                </div>
                                <div className="bar-title w-100">US5</div>
                            </li>
                            <li>
                                <div className="full-bar" style={{ height: '76%' }}>
                                    <div className="total-bar" style={{ height: '15%' }}>25</div>
                                    <div className="sun-total-bar progress-red-color" style={{ height: '85%' }}>23</div>
                                </div>
                                <div className="bar-title w-100">US6</div>
                            </li>
                            <li>
                                <div className="full-bar" style={{ height: '80%' }}>
                                    <div className="total-bar" style={{ height: '5%' }}>29</div>
                                    <div className="sun-total-bar progress-red-color" style={{ height: '90%' }}>27</div>
                                </div>
                                <div className="bar-title w-100">US7</div>
                            </li>

                        </ul>
                    </div> */}
                </div>
            )
        } else {
            return null;
        }

    }
}

export default DashboardHybrids;
